export default __webpack_public_path__ + "static/media/15.e35a5d10.jpg";